import { configureErrorHandler } from '@peloton/error-reporting';
import {
  consoleErrorReporter,
  newRelicErrorReporter,
} from '@peloton/error-reporting/reporters';
import { commitSHA } from '@members/env';
import * as Env from '@members/env';

const isLocalEnv = Env.isLocalEnv();
const isProdEnv = Env.isProdEnv();
export const setupErrorHandler = (env: any) =>
  configureErrorHandler(
    [
      ...(isProdEnv ? [] : [consoleErrorReporter]),
      ...(isLocalEnv ? [] : [newRelicErrorReporter]),
    ],
    {
      environment: env.error,
      release: `web-engage@${commitSHA}`,
    },
  );
